
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-660.697 -244.531)"}},[_c('path',{attrs:{"d":"M679.462 249.031a2.118 2.118 0 012.056 2.172v7.284a.686.686 0 11-1.37 0V251.2a.707.707 0 00-.686-.724h-13.708a.706.706 0 00-.685.724v9.523a.705.705 0 00.685.724h6.854a.725.725 0 010 1.448h-6.854a2.119 2.119 0 01-2.057-2.172V251.2a2.119 2.119 0 012.057-2.172z"}}),_c('path',{attrs:{"d":"M669.785 254.3a.749.749 0 01.75-.749h4.5a.75.75 0 010 1.5h-4.5a.751.751 0 01-.751-.749z"}}),_c('circle',{attrs:{"cx":".749","cy":".749","r":".749","transform":"translate(667.49 253.554)"}}),_c('path',{attrs:{"d":"M669.785 257.358a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.749.749 0 01-.751-.748z"}}),_c('circle',{attrs:{"cx":".749","cy":".749","r":".749","transform":"translate(667.49 256.608)"}}),_c('path',{attrs:{"stroke":"#1b5be9","d":"M680.193 261.977h-1.891v-1.891a.304.304 0 00-.609 0v1.891h-1.892a.304.304 0 000 .609h1.892v1.891a.304.304 0 10.609 0v-1.891h1.891a.304.304 0 000-.609z"}})])])
          )
        }
      }
    